import type { ReactElement } from "react";

import { Wallpaper } from "./Wallpaper.js";

export type WallpaperGridProps = {
	items: {
		desktop_link: string;
		mobile_link: string;
		thumbnail: string;
	}[];
	language: "EN" | "FR";
};

/**
 * Display the wallpaper grid.
 *
 * @param props The properties for the component.
 * @returns The wallpaper grid.
 */
export function WallpaperGrid(props: WallpaperGridProps): ReactElement {
	const { items, language } = props;
	return (
		<div className="hl:grid hl:gap-4 hl:lg:grid-cols-2">
			{items.map((item, index) => (
				<Wallpaper
					desktop_link={item.desktop_link}
					key={index}
					language={language}
					mobile_link={item.mobile_link}
					thumbnail={item.thumbnail}
				/>
			))}
		</div>
	);
}
